export default __webpack_public_path__ + "static/media/messages.18d35687.png";